import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as employeeSkill from '../../employee-skills'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between an Employee and a Skill. An Employee may have multiple Skills and Skills can be associated with multiple employees.',
    dimension: employeeSkill.RESOURCE.payload,
    level: 0,
    name: 'Employee-Skill',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
